(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["batch-waitlist"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('batch-waitlist')) {
    class BatchWaitlist extends HTMLElement {
      connectedCallback() {
        this._form = this.querySelector('form');
        this._onSubmit = () => {
          try { sessionStorage.setItem('mk:posted', 'waitlist'); } catch (e) {}
          document.dispatchEvent(new CustomEvent('analytics:generate_lead', {
            detail: { source: 'batch_waitlist', item_name: this.dataset.productTitle }
          }));
        };
        this._form?.addEventListener('submit', this._onSubmit);
        this._onAltClick = (event) => {
          const alt = event.target.closest('.batch-waitlist__alt');
          if (!alt) return;
          document.dispatchEvent(new CustomEvent('analytics:select_item', {
            detail: { item_id: Number(alt.dataset.productId), item_name: alt.dataset.productTitle, item_list_name: 'sold_out_alternatives' }
          }));
        };
        this.addEventListener('click', this._onAltClick);

        // posted_successfully? is true for every customer form on the page, so the footer
        // newsletter's reload would show this success too. Keep it only when the submit
        // came from here (marker set in _onSubmit; no storage = trust the server render).
        const ok = this.querySelector('[data-waitlist-success]');
        if (ok) {
          let mine = true;
          try { mine = sessionStorage.getItem('mk:posted') === 'waitlist'; if (mine) sessionStorage.removeItem('mk:posted'); } catch (e) {}
          if (!mine) {
            ok.remove();
            this.querySelector('[data-waitlist-fields]')?.removeAttribute('hidden');
          } else if (new URLSearchParams(location.search).has('customer_posted')) {
            // Post-submit reload only: bring the confirmation into view. Never scrolls on a
            // normal landing — a load-time scroll would stop Chromium's LCP tracking.
            this.scrollIntoView({ block: 'center' });
          }
        }
      }
      disconnectedCallback() {
        this._form?.removeEventListener('submit', this._onSubmit);
        this.removeEventListener('click', this._onAltClick);
      }
    }
    customElements.define('batch-waitlist', BatchWaitlist);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["home-video"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mk-video')) {
    customElements.define('mk-video', class extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        if (!this.video) return;
        var save = navigator.connection && navigator.connection.saveData;
        var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (save || reduce || /static/.test(location.search)) return;
        this.ready = this.dataset.mode !== 'hero';
        this.visible = false;
        this.onPlaying = () => { this.video.hidden = false; };
        this.video.addEventListener('playing', this.onPlaying);
        if ('IntersectionObserver' in window) {
          this.io = new IntersectionObserver((es) => {
            this.visible = es[es.length - 1].isIntersecting;
            this.sync();
          }, { threshold: 0.35 });
          this.io.observe(this.parentElement || this.video);
        } else {
          this.visible = true;
        }
        if (!this.ready) {
          this.arm = () => {
            var go = () => { this.ready = true; this.sync(); };
            this.idle = window.requestIdleCallback ? window.requestIdleCallback(go, { timeout: 2500 }) : setTimeout(go, 600);
          };
          if (document.readyState === 'complete') this.arm();
          else window.addEventListener('load', this.arm, { once: true });
        }
      }
      sync() {
        var v = this.video;
        if (!this.ready || !v) return;
        if (this.visible) {
          if (!v.getAttribute('src')) v.setAttribute('src', v.dataset.src);
          var p = v.play();
          if (p && p.catch) p.catch(function () {});
        } else if (!v.paused) {
          v.pause();
        }
      }
      disconnectedCallback() {
        if (this.io) this.io.disconnect();
        if (this.arm) window.removeEventListener('load', this.arm);
        if (this.idle) {
          if (window.cancelIdleCallback) window.cancelIdleCallback(this.idle);
          clearTimeout(this.idle);
        }
        if (this.video) {
          this.video.removeEventListener('playing', this.onPlaying);
          this.video.pause();
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tea-filters"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mk-tea-filters')) {
    class MkTeaFilters extends HTMLElement {
      connectedCallback() {
        this.grid = document.getElementById(this.dataset.grid);
        if (!this.grid) return;
        this.countEl = document.getElementById(this.dataset.count);
        this.cards = Array.from(this.grid.querySelectorAll('.tcard'));
        this.orig = Array.from(this.grid.children);
        this.want = { type: '', form: '', moment: '', band: '' };
        this.cf = this.querySelector('[data-cf-toggle]');
        this.sort = this.querySelector('[data-sort]');
        this.onClick = (e) => {
          const link = e.target.closest('a.fchip');
          if (link && this.contains(link)) {
            const g = link.closest('.fgroup'), lab = g && g.querySelector('.flabel');
            this.track(lab ? lab.textContent.trim() : 'filter', link.classList.contains('on') ? '' : link.firstChild.textContent.trim());
            return;
          }
          const b = e.target.closest('button[data-f]');
          if (!b || !this.contains(b)) return;
          this.want[b.dataset.f] = b.dataset.v;
          this.track(b.dataset.f, b.dataset.v);
          this.querySelectorAll('button[data-f="' + b.dataset.f + '"]').forEach((x) => {
            x.classList.toggle('on', x === b);
            x.setAttribute('aria-pressed', x === b ? 'true' : 'false');
          });
          this.apply();
        };
        this.onChange = (e) => {
          if (e.target === this.cf) this.track('caffeine_free', this.cf.checked ? '1' : '');
          else if (e.target === this.sort) this.track('sort', this.sort.value);
          this.apply();
        };
        this.addEventListener('click', this.onClick);
        this.addEventListener('change', this.onChange);
        this.counts();
        this.apply();
      }

      disconnectedCallback() {
        if (!this.onClick) return;
        this.removeEventListener('click', this.onClick);
        this.removeEventListener('change', this.onChange);
      }

      track(name, value) {
        try {
          document.dispatchEvent(new CustomEvent('analytics:filter_applied', { detail: { filter_name: name, filter_value: String(value) } }));
        } catch (e) { /* analytics best-effort */ }
      }

      match(c, f, v) {
        if (!v) return true;
        if (f === 'moment') return (c.dataset.moment || '').split(' ').indexOf(v) >= 0;
        return c.dataset[f] === v;
      }

      counts() {
        this.querySelectorAll('.fgroup[data-js]').forEach((g) => {
          let any = false;
          g.querySelectorAll('button[data-f]').forEach((b) => {
            if (!b.dataset.v) return;
            const n = this.cards.filter((c) => this.match(c, b.dataset.f, b.dataset.v)).length;
            const small = b.querySelector('small');
            if (small) small.textContent = n;
            b.hidden = n === 0;
            if (n) any = true;
          });
          if (g.querySelector('button[data-f]') && !any) g.hidden = true;
        });
        const cfWrap = this.querySelector('[data-cf-wrap]');
        if (cfWrap) cfWrap.hidden = !this.cards.some((c) => c.dataset.cf === '1');
        if (!this.cards.length) this.hidden = true;
      }

      apply() {
        const cf = this.cf && this.cf.checked;
        const sort = this.sort ? this.sort.value : '';
        let shown = 0;
        this.cards.forEach((c) => {
          const ok = this.match(c, 'type', this.want.type) && this.match(c, 'form', this.want.form) &&
            this.match(c, 'moment', this.want.moment) && this.match(c, 'band', this.want.band) &&
            (!cf || c.dataset.cf === '1');
          c.hidden = !ok;
          if (ok) shown++;
        });
        const list = sort
          ? this.orig.filter((el) => el.classList.contains('tcard')).sort((a, b) => (sort === 'asc' ? 1 : -1) * (a.dataset.price - b.dataset.price))
          : this.orig;
        if (sort) this.orig.filter((el) => !el.classList.contains('tcard')).forEach((el) => list.push(el));
        list.forEach((el) => this.grid.appendChild(el));
        const filtered = !!(sort || cf || this.want.type || this.want.form || this.want.moment || this.want.band);
        this.grid.querySelectorAll('.tpromo').forEach((p) => { p.hidden = filtered; });
        if (this.countEl) {
          this.countEl.textContent = (shown === 1 ? this.dataset.one : this.dataset.other).replace('[n]', shown);
        }
      }
    }
    customElements.define('mk-tea-filters', MkTeaFilters);
  }
  } catch(e) { console.error(e); }
})();

})();
